import request from '../utils/request'

export function modifyIndustry(industry) {
    return request({
        url: '/api/industry/modify',
        method: 'post',
        data: industry
    })
}


export function deleteIndustry(industryId) {
    return request({
        url: '/api/com/delete',
        params: {
            table: 'sys_industry',
            id: industryId
        }
    })
}